export default __webpack_public_path__ + "static/p4-6ecc48036e3974c22644c2f9bbf9f454.png";